/* ==========================================================================
   tws-fiche-3.js — Fiche montre 3.0 — 02/10/2026, revu les 03, 04, 06 et 07/10/2026
   Chargé en defer uniquement sur les fiches produit 3.0 (templates « -3-0 » et
   template produit par défaut)
   (layout/theme.liquid).
     1. Carrousels des sections tws3-* (barre de progression, flèches,
        hauteur calée sur la carte affichée, un geste = une carte ;
        data-fondu : sur ordinateur, les cartes se succèdent en fondu)
     2. Bouton d'achat : prix du pack choisi dans le bouton et la barre fixe
     3. Barre d'achat fixe visible dès le haut de la page
     4. Suggestions : chargement différé des recommandations Shopify
     5. Étapes : panneaux extensibles sur ordinateur
     6. Savoir-faire : bandeau de phrases (une à la fois, flèches)
     7. Savoir-faire : textes longs repliés sur mobile (« Lire la suite »)
     8. Essence du bois cliquable dans la ligne de caractéristiques
   07/10/2026 (demande Laurent) : PLUS AUCUN DÉFILEMENT AUTOMATIQUE. Carrousels,
   panneaux et bandeau de phrases ne bougent que lorsque le visiteur les
   manipule (flèches, glissement, clic). Les réglages data-auto / data-delai des
   sections sont ignorés (constante AUTO ci-dessous). Pour réactiver : AUTO = true.
   ========================================================================== */
(function () {
  'use strict';

  var AUTO = false;

  function mobile() {
    return window.matchMedia('(max-width: 989px)').matches;
  }

  /* ---------- 1. Carrousels ---------- */
  function initCarrousel(racine) {
    if (racine.dataset.tws3Pret) return;
    var piste = racine.querySelector('[data-piste]');
    if (!piste || !piste.children.length) return;
    racine.dataset.tws3Pret = '1';

    var cartes = piste.children;
    var n = cartes.length;
    var barre = racine.querySelector('[data-prog]');
    var fleches = racine.querySelectorAll('[data-dir]');
    var adapte = racine.hasAttribute('data-adapt');
    var fondu = racine.hasAttribute('data-fondu');
    var delai = AUTO ? parseInt(racine.getAttribute('data-auto') || '0', 10) * 1000 : 0;
    var idx = 0;
    var arrete = false;
    var visible = false;
    var minuteur = null;
    var depart = null; /* rang de la carte calée quand le doigt se pose */
    var doigt = false;
    var repos = null;

    /* Mode fondu (ordinateur) : pas de défilement, la carte active porte
       .is-active et le CSS fait le reste. */
    function enFondu() {
      return fondu && !mobile();
    }
    function marque(i) {
      for (var k = 0; k < n; k++) cartes[k].classList.toggle('is-active', k === i);
    }
    function pas() {
      return n > 1 ? cartes[1].offsetLeft - cartes[0].offsetLeft : piste.clientWidth;
    }
    /* Hauteur de la piste = hauteur de la carte affichée : les flèches restent
       collées sous le texte, même quand les cartes n'ont pas la même longueur. */
    function ajuste() {
      if (!adapte) return;
      piste.style.height = mobile() ? cartes[idx].offsetHeight + 'px' : '';
    }
    /* Flèche grisée (ou masquée, selon la section) quand on est au bout.
       En fondu il n'y a pas de bout : la dernière carte reboucle. */
    function etatFleches(debut, fin) {
      fleches.forEach(function (b) {
        b.disabled = b.getAttribute('data-dir') === '-1' ? debut : fin;
      });
    }
    /* Un geste = une carte. scroll-snap-stop (CSS) empêche déjà l'élan de sauter
       une carte ; ici on borne aussi le glissement lui-même : tant que le geste
       n'est pas terminé, la piste ne s'éloigne pas de plus d'une carte de celle
       où il a commencé. Réservé aux pistes qui montrent une carte à la fois
       (carte plus large que la moitié de la piste) : les suggestions, plus
       petites, se feuillettent librement. */
    function borne() {
      if (depart === null) return;
      var p = pas() || 1;
      if (p <= piste.clientWidth / 2) return;
      var max = piste.scrollWidth - piste.clientWidth;
      var bas = (depart - 1) * p;
      var haut = (depart + 1) * p;
      /* Aux deux bouts, le bord de la piste suffit : on ne touche pas au rebond. */
      if (bas > 0 && piste.scrollLeft < bas - 1) piste.scrollLeft = bas;
      else if (haut < max && piste.scrollLeft > haut + 1) piste.scrollLeft = haut;
    }
    /* Le geste est terminé quand le doigt est levé et que la piste ne bouge plus. */
    function attendRepos() {
      if (repos) clearTimeout(repos);
      repos = setTimeout(function () { if (!doigt) depart = null; }, 160);
    }
    function maj() {
      if (depart !== null) {
        borne();
        if (!doigt) attendRepos();
      }
      if (enFondu()) {
        if (barre) barre.style.width = ((idx + 1) / n) * 100 + '%';
        etatFleches(false, false);
        return;
      }
      var max = piste.scrollWidth - piste.clientWidth;
      var f = max > 0 ? piste.scrollLeft / max : 0;
      if (barre) barre.style.width = 100 / n + f * (100 - 100 / n) + '%';
      etatFleches(piste.scrollLeft <= 2, piste.scrollLeft >= max - 2);
      /* Rang de la carte calée à gauche. Compté en largeurs de carte : juste
         aussi quand plusieurs cartes sont visibles à la fois. */
      var i = Math.min(n - 1, Math.max(0, Math.round(piste.scrollLeft / (pas() || 1))));
      if (i !== idx) {
        idx = i;
        marque(idx);
        ajuste();
      }
    }
    function va(i) {
      depart = null; /* flèches et défilement automatique : pas de borne */
      if (enFondu()) {
        idx = i;
        marque(idx);
        maj();
        return;
      }
      piste.scrollTo({ left: i * pas(), behavior: 'smooth' });
    }
    function stop() {
      arrete = true;
      if (minuteur) clearInterval(minuteur);
    }

    piste.addEventListener('scroll', maj, { passive: true });
    piste.addEventListener('touchstart', function () {
      if (enFondu()) return;
      if (repos) clearTimeout(repos);
      doigt = true;
      depart = Math.round(piste.scrollLeft / (pas() || 1));
    }, { passive: true });
    ['touchend', 'touchcancel'].forEach(function (ev) {
      piste.addEventListener(ev, function () {
        doigt = false;
        attendRepos();
      }, { passive: true });
    });
    /* Une carte a changé de hauteur (texte déplié) : la piste suit. */
    racine.addEventListener('tws3:taille', ajuste);
    /* Passage mobile <-> ordinateur : on garde la même carte. */
    var modeFondu = enFondu();
    window.addEventListener('resize', function () {
      if (enFondu() !== modeFondu) {
        modeFondu = enFondu();
        if (!modeFondu) piste.scrollLeft = idx * pas();
        maj();
      }
      ajuste();
    });
    window.addEventListener('load', ajuste);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(ajuste);
    Array.prototype.forEach.call(piste.querySelectorAll('img'), function (img) {
      if (!img.complete) img.addEventListener('load', ajuste, { once: true });
    });
    marque(idx);
    maj();
    ajuste();

    fleches.forEach(function (b) {
      b.addEventListener('click', function () {
        stop();
        var cible = idx + parseInt(b.getAttribute('data-dir'), 10);
        /* En fondu, la dernière carte reboucle sur la première */
        va(enFondu() ? (cible + n) % n : Math.min(n - 1, Math.max(0, cible)));
      });
    });

    /* Défilement automatique (désactivé depuis le 07/10/2026 : AUTO = false) :
       mobile uniquement, seulement quand le carrousel est à l'écran, et arrêté
       définitivement au premier toucher. */
    if (delai > 0 && n > 1) {
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }, { threshold: 0.5 }).observe(piste);
      } else {
        visible = true;
      }
      var patience = 0;
      minuteur = setInterval(function () {
        if (arrete || !visible || !mobile()) return;
        /* Une carte marquée data-long (l'introduction) reste deux fois plus longtemps */
        if (cartes[idx].hasAttribute('data-long') && patience < 1) { patience++; return; }
        patience = 0;
        va((idx + 1) % n);
      }, delai);
      ['pointerdown', 'touchstart'].forEach(function (ev) {
        piste.addEventListener(ev, stop, { passive: true });
      });
    }
  }

  function initCarrousels(dans) {
    (dans || document).querySelectorAll('[data-tws3-carousel]').forEach(initCarrousel);
  }

  /* ---------- 2. Prix dans le bouton d'achat ---------- */
  function prixCourant() {
    var pack = document.querySelector('.tws-pack__card.active .tws-pack__price');
    if (pack) return pack.textContent.trim();
    var p = document.querySelector('.product__info-container .price .price-item--sale, .product__info-container .price .price-item--regular');
    return p ? p.textContent.trim() : '';
  }
  function majPrix() {
    var prix = prixCourant();
    var bouton = document.querySelector('.product-form__buttons > .product-form__submit');
    if (bouton && !bouton.disabled && prix) {
      var cible = bouton.querySelector('.tws3-cta-prix');
      if (!cible) {
        cible = document.createElement('em');
        cible.className = 'tws3-cta-prix';
        (bouton.querySelector('div') || bouton).appendChild(cible);
      }
      cible.textContent = prix;
    }
    var fixe = document.querySelector('#stickyAddtocartContainer .sticky-product-price');
    if (fixe && prix) fixe.textContent = prix;
  }

  /* ---------- 3. Barre d'achat fixe ---------- */
  function initBarre() {
    var barre = document.getElementById('stickyAddtocartContainer');
    if (!barre) return;
    var nom = document.querySelector('.tws3-titre__nom');
    var zone = barre.querySelector('.delivery-text-container');
    if (nom && zone && !zone.querySelector('.tws3-sticky-nom')) {
      var el = document.createElement('div');
      el.className = 'tws3-sticky-nom';
      el.textContent = nom.textContent.trim();
      zone.insertBefore(el, zone.firstChild);
    }
    /* Le script du thème ne décide de l'affichage qu'au premier défilement :
       on le déclenche une fois pour que la barre soit là dès le chargement. */
    window.dispatchEvent(new Event('scroll'));
  }

  /* ---------- 4. Suggestions ----------
     Au premier rendu, Shopify ne fournit pas encore les recommandations : on
     rappelle la section (data-url) quand elle approche de l'écran, on injecte
     les cartes, puis on initialise le carrousel. */
  function initSuggestions() {
    document.querySelectorAll('[data-tws3-reco]').forEach(function (zone) {
      if (zone.querySelector('.tws3-reco__carte')) { initCarrousels(zone); return; }
      /* La zone est vide au départ et base.css masque les div vides (display:none) :
         on observe donc la section qui l'entoure, pas la zone elle-même. */
      var section = zone.closest('.tws3-reco');
      function charge() {
        fetch(zone.getAttribute('data-url'))
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var tmp = document.createElement('div');
            tmp.innerHTML = html;
            var neuf = tmp.querySelector('[data-tws3-reco]');
            if (neuf && neuf.innerHTML.trim().length) {
              zone.innerHTML = neuf.innerHTML;
              initCarrousels(zone);
            } else if (section) {
              section.style.display = 'none'; /* aucune recommandation : pas de bande vide */
            }
          })
          .catch(function (e) { console.error(e); });
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (e, obs) {
          if (!e[0].isIntersecting) return;
          obs.disconnect();
          charge();
        }, { rootMargin: '0px 0px 400px 0px' }).observe(section || zone);
      } else {
        charge();
      }
    });
  }

  /* ---------- 5. Étapes : panneaux extensibles (ordinateur) ----------
     Le panneau actif porte .is-active (la largeur est gérée en CSS). Il change
     au clic. (Changement automatique toutes les data-delai secondes : désactivé
     depuis le 07/10/2026, AUTO = false.)
     Sur mobile, la même piste reste un carrousel : rien ne se passe ici. */
  function initPanneaux(piste) {
    if (piste.dataset.tws3Panneaux === 'pret') return;
    var cartes = piste.children;
    var n = cartes.length;
    if (n < 2) return;
    piste.dataset.tws3Panneaux = 'pret';

    var delai = AUTO ? parseInt(piste.getAttribute('data-delai') || '0', 10) * 1000 : 0;
    var idx = 0;
    var arrete = false;
    var visible = false;
    var survol = false;

    function active(i) {
      idx = i;
      for (var k = 0; k < n; k++) cartes[k].classList.toggle('is-active', k === i);
    }
    Array.prototype.forEach.call(cartes, function (carte, i) {
      carte.setAttribute('tabindex', '0');
      carte.addEventListener('click', function () {
        if (mobile()) return;
        arrete = true;
        active(i);
      });
      carte.addEventListener('keydown', function (e) {
        if (mobile() || (e.key !== 'Enter' && e.key !== ' ')) return;
        e.preventDefault();
        arrete = true;
        active(i);
      });
    });
    piste.addEventListener('mouseenter', function () { survol = true; });
    piste.addEventListener('mouseleave', function () { survol = false; });

    if (delai > 0) {
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }, { threshold: 0.4 }).observe(piste);
      } else {
        visible = true;
      }
      setInterval(function () {
        if (arrete || survol || !visible || mobile()) return;
        active((idx + 1) % n);
      }, delai);
    }
  }

  /* ---------- 6. Savoir-faire : bandeau de phrases ----------
     Une phrase à la fois (.is-active), deux flèches qui bouclent, glissement
     au doigt. (Défilement automatique toutes les data-delai secondes : désactivé
     depuis le 07/10/2026, AUTO = false.) */
  function initPhrases(zone) {
    if (zone.dataset.tws3Phrases === 'pret') return;
    var phrases = zone.querySelectorAll('li');
    var n = phrases.length;
    if (n < 2) return;
    zone.dataset.tws3Phrases = 'pret';

    var delai = AUTO ? parseInt(zone.getAttribute('data-delai') || '0', 10) * 1000 : 0;
    var idx = 0;
    var arrete = false;
    var visible = false;
    var survol = false;
    var x0 = null;

    function va(i) {
      idx = (i + n) % n;
      for (var k = 0; k < n; k++) phrases[k].classList.toggle('is-active', k === idx);
    }
    zone.querySelectorAll('[data-phrase]').forEach(function (b) {
      b.addEventListener('click', function () {
        arrete = true;
        va(idx + parseInt(b.getAttribute('data-phrase'), 10));
      });
    });
    zone.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    zone.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      x0 = null;
      if (Math.abs(dx) < 30) return;
      arrete = true;
      va(idx + (dx < 0 ? 1 : -1));
    }, { passive: true });
    /* Pause au survol, à la souris seulement : sur un écran tactile, un simple
       toucher resterait compté comme un survol et bloquerait le défilement. */
    zone.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') survol = true; });
    zone.addEventListener('pointerleave', function () { survol = false; });

    if (delai > 0) {
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }, { threshold: 0.6 }).observe(zone);
      } else {
        visible = true;
      }
      setInterval(function () {
        if (arrete || survol || !visible) return;
        va(idx + 1);
      }, delai);
    }
  }

  /* ---------- 7. Savoir-faire : textes longs repliés (mobile) ----------
     Sur mobile, une carte doit tenir à l'écran avec son image. Un texte trop
     long est replié (classe .is-plie, la hauteur vient de --tws3-pli) et reçoit
     un bouton « Lire la suite », posé au bout de la dernière ligne visible.
     Deux réglages : une carte qui porte déjà une réponse courte
     (.tws3-sf__reponse) ne montre que 3 lignes, repliées dès la 4e ; les autres
     en montrent 5 et ne sont repliées qu'à partir de 8 lignes. Le
     texte reste entier dans la page : il est seulement masqué par la hauteur.
     Sur ordinateur, le CSS ignore le repli et masque le bouton. */
  var PLI = { reponse: { lignes: 3, seuil: 3 }, seul: { lignes: 5, seuil: 7 } };
  function plie(texte) {
    var bouton = texte.nextElementSibling;
    if (!bouton || !bouton.classList.contains('tws3-sf__suite')) bouton = null;
    if (texte.dataset.tws3Ouvert) return;
    texte.classList.remove('is-plie');
    var ligne = parseFloat(getComputedStyle(texte).lineHeight) || parseFloat(getComputedStyle(texte).fontSize) * 1.75;
    var carte = texte.closest('.tws3-sf__carte');
    var regle = carte && carte.querySelector('.tws3-sf__reponse') ? PLI.reponse : PLI.seul;
    var long = mobile() && texte.scrollHeight > ligne * regle.seuil + 6;
    if (!long) {
      if (bouton) bouton.hidden = true;
      return;
    }
    texte.style.setProperty('--tws3-pli', (ligne * regle.lignes).toFixed(2) + 'px');
    texte.classList.add('is-plie');
    if (!bouton) {
      bouton = document.createElement('button');
      bouton.type = 'button';
      bouton.className = 'tws3-sf__suite';
      bouton.textContent = 'Lire la suite';
      bouton.setAttribute('aria-expanded', 'false');
      bouton.addEventListener('click', function () {
        var ouvert = texte.classList.contains('is-plie');
        texte.classList.toggle('is-plie', !ouvert);
        if (ouvert) texte.dataset.tws3Ouvert = '1';
        else delete texte.dataset.tws3Ouvert;
        bouton.textContent = ouvert ? 'Réduire' : 'Lire la suite';
        bouton.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
        texte.dispatchEvent(new CustomEvent('tws3:taille', { bubbles: true }));
      });
      texte.insertAdjacentElement('afterend', bouton);
    }
    bouton.style.setProperty('--tws3-ligne', ligne.toFixed(2) + 'px');
    bouton.hidden = false;
  }
  function initPlis() {
    var textes = document.querySelectorAll('.tws3-sf__carte .tws3-sf__texte');
    if (!textes.length) return;
    function tous() {
      textes.forEach(plie);
      document.querySelectorAll('.tws3-sf').forEach(function (s) {
        s.dispatchEvent(new CustomEvent('tws3:taille'));
      });
    }
    tous();
    /* Largeur changée (rotation, passage mobile <-> ordinateur) ou police
       arrivée après coup : le nombre de lignes n'est plus le même. */
    var largeur = window.innerWidth;
    var attente = null;
    window.addEventListener('resize', function () {
      if (window.innerWidth === largeur) return;
      largeur = window.innerWidth;
      if (attente) clearTimeout(attente);
      attente = setTimeout(tous, 150);
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(tous);
  }

  /* ---------- 8. Essence du bois cliquable (07/10/2026) ----------
     La ligne de caractéristiques sous le titre (.tws3-specs) affiche le nom du
     bois en texte simple (sortie échappée par main-product). On le transforme
     en lien vers la collection de l'essence. Le lien « Essence du bois » de la
     section Détails techniques, lui, est écrit côté serveur (tws3-details),
     pour que Google le voie sans JavaScript. */
  var ESSENCES = {
    'bambou': 'bambou', 'zebrano': 'bois-de-zebrano', 'zébrano': 'bois-de-zebrano',
    'noyer': 'bois-de-noyer', 'ébène': 'bois-d-ebene', 'ebène': 'bois-d-ebene', 'ebene': 'bois-d-ebene',
    'koa': 'bois-de-koa', 'acajou': 'bois-d-acajou', 'olivier': 'bois-d-olivier'
  };
  function initEssence() {
    document.querySelectorAll('.tws3-specs span').forEach(function (s) {
      if (s.children.length || s.closest('a')) return;
      var nom = s.textContent.trim();
      var cle = ESSENCES[nom.toLowerCase()];
      if (!cle) return;
      var a = document.createElement('a');
      a.href = '/collections/' + cle;
      a.textContent = nom;
      a.title = 'Tous nos accessoires en ' + nom.toLowerCase();
      a.style.color = 'inherit';
      a.style.textDecoration = 'underline';
      a.style.textUnderlineOffset = '2px';
      s.textContent = '';
      s.appendChild(a);
    });
  }

  /* 9. PHOTO À GRAVER (08/10/2026) — remplace l'application d'envoi de photo payante.
     Sur les fiches dont un tag contient « personnalis » (sauf « texte »), un champ
     « Choisir ma photo » est ajouté dans le formulaire d'achat, juste avant le bouton.
     La photo part avec l'ajout au panier (propriété de ligne « Photo à graver ») :
     Shopify la stocke et le lien apparaît dans le détail de la commande.
     Tant que l'application est installée, son bouton reste prioritaire et ce champ ne
     s'affiche pas (pas de doublon) ; pour tester : ajouter ?tws_photo=1 à l'adresse. */
  function initPhotoGravure() {
    var form = document.querySelector('product-form form[action*="/cart/add"]');
    if (!form || form.querySelector('.tws-photo')) return;
    var forcer = /[?&]tws_photo=1/.test(location.search);
    if (document.querySelector('.uploadkit-upload-field') && !forcer) return;
    var chemin = location.pathname.replace(/\/$/, '');
    if (chemin.indexOf('/products/') === -1) return;
    fetch(chemin + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.tags) return;
        var tags = p.tags.join(',').toLowerCase();
        if (tags.indexOf('personnalis') === -1 || tags.indexOf('texte') !== -1) return;
        if (forcer) {
          document.querySelectorAll('.uploadkit-upload-field, .uploadkit-uploader').forEach(function (el) { el.style.display = 'none'; });
          form.classList.remove('uploadkit-invalid');
        }
        if (!document.getElementById('tws-photo-css')) {
          var st = document.createElement('style');
          st.id = 'tws-photo-css';
          st.textContent = '.tws-photo{margin:18px 0 14px}.tws-photo__titre{display:block;margin:0 0 8px;font-size:10.5px;letter-spacing:.2em;text-transform:uppercase;color:#1a1a1a}.tws-photo__titre span{color:#8a7347;letter-spacing:.08em;text-transform:none}.tws-photo__zone{position:relative;display:flex;align-items:center;gap:14px;padding:14px 16px;border:1px dashed #a98f5f;background:#fbfaf7;cursor:pointer}.tws-photo__zone:focus-within{outline:1px solid #1a1a1a;outline-offset:2px}.tws-photo__zone input{position:absolute;inset:0;width:100%;height:100%;opacity:0;cursor:pointer}.tws-photo__apercu{flex:0 0 56px;width:56px;height:56px;object-fit:cover;background:#efe9df}.tws-photo__apercu[hidden]{display:none}.tws-photo__cta{font-size:12px;letter-spacing:.16em;text-transform:uppercase;color:#1a1a1a;border-bottom:1px solid #a98f5f}.tws-photo__nom{display:block;margin-top:4px;font-size:12px;color:#6f6a62;word-break:break-all}.tws-photo__aide{margin:8px 0 0;font-size:12px;line-height:1.5;color:#6f6a62}.tws-photo__erreur{margin:6px 0 0;font-size:12px;color:#b3261e}';
          document.head.appendChild(st);
        }
        var bloc = document.createElement('div');
        bloc.className = 'tws-photo';
        bloc.innerHTML =
          '<span class="tws-photo__titre">Votre photo à graver <span>(obligatoire)</span></span>' +
          '<label class="tws-photo__zone">' +
            '<img class="tws-photo__apercu" alt="" hidden>' +
            '<span><span class="tws-photo__cta">Choisir ma photo</span><span class="tws-photo__nom">Aucune photo choisie</span></span>' +
            '<input type="file" name="properties[Photo à graver]" accept="image/jpeg,image/png" required aria-label="Choisir la photo à graver">' +
          '</label>' +
          '<p class="tws-photo__aide">Une photo nette, carrée de préférence (JPG ou PNG, 20 Mo maximum). Elle est jointe à votre commande : nous vous contactons si elle ne convient pas à la gravure.</p>' +
          '<p class="tws-photo__erreur" hidden></p>';
        var boutons = form.querySelector('.product-form__buttons');
        if (boutons) boutons.parentNode.insertBefore(bloc, boutons); else form.appendChild(bloc);
        var input = bloc.querySelector('input');
        var apercu = bloc.querySelector('.tws-photo__apercu');
        var nom = bloc.querySelector('.tws-photo__nom');
        var erreur = bloc.querySelector('.tws-photo__erreur');
        function message(t) { erreur.textContent = t; erreur.hidden = !t; input.setCustomValidity(t); }
        input.addEventListener('invalid', function () {
          if (!input.files.length) { input.setCustomValidity('Ajoutez votre photo à graver avant d\'ajouter au panier.'); erreur.textContent = 'Ajoutez votre photo à graver avant d\'ajouter au panier.'; erreur.hidden = false; }
        });
        input.addEventListener('change', function () {
          message('');
          var f = input.files[0];
          if (!f) { nom.textContent = 'Aucune photo choisie'; apercu.hidden = true; return; }
          if (f.size > 20 * 1024 * 1024) { message('Cette photo dépasse 20 Mo : choisissez une version plus légère.'); return; }
          nom.textContent = f.name;
          try { apercu.src = URL.createObjectURL(f); apercu.hidden = false; } catch (e) {}
        });
      })
      .catch(function () {});
  }

  function init() {
    initPlis();
    initCarrousels();
    document.querySelectorAll('[data-tws3-panneaux]').forEach(initPanneaux);
    document.querySelectorAll('[data-tws3-phrases]').forEach(initPhrases);
    initEssence();
    majPrix();
    initBarre();
    ['click', 'keyup'].forEach(function (ev) {
      document.addEventListener(ev, function (e) {
        if (e.target.closest && e.target.closest('[data-tws-pack-option]')) setTimeout(majPrix, 0);
      });
    });
    initSuggestions();
    initPhotoGravure();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
